import messages from "i18n/messages";
import first from "lodash/first";
import { Background } from "components/index";
import flowRight from "lodash/flowRight";
import moment from "moment";
import { makeSelectCurOrg } from "logic/orgs";
import {
  fetchWaitingRoomVisitor,
  makeSelectWaitingRoomVisitor,
} from "logic/dates";
import React from "react";
import { injectIntl, FormattedMessage, FormattedDate } from "react-intl";
import { defaultDateFormat } from "../lib/misc";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { createStructuredSelector } from "reselect";

const WaitingRoom = ({ visitor, date, event }) => {
  const eventImgSrc =
    event.images && first(event.images) ? first(event.images).full : null;
  const tkTime = visitor ? moment(visitor.ts) : moment();
  return (
    <div className="tt-waiting-room-wrap">
      <div className="tt-waiting-room-box">
        <Background noBlur imgSrc={eventImgSrc} />
        <div className="p-4">
          <div className="pb-4">
            <div className="wr-title">
              <FormattedMessage {...messages.waitingRoom} />
            </div>
            <div className="title">{date && date.title}</div>
            <div className="subtitle text-center">{date && date.subtitle}</div>
            <div className="subtitle text-center font-weight-bold">
              <FormattedDate
                value={date && date.starts_at}
                {...defaultDateFormat}
              />
            </div>
            <div className="text-center mt-4">
              <div className="text-center">
                <div className="desc">
                  <FormattedMessage {...messages.waitingRoomDesc} />
                </div>
              </div>
              <div className="wr-pos-wrap">
                {visitor ? (
                  <div className="wr-pos">
                    <div className="wr-pos-pos">
                      {visitor ? visitor.pos : "-"}
                    </div>
                    <div className="wr-pos-desc">
                      <FormattedMessage {...messages.position} />
                    </div>
                  </div>
                ) : (
                  <div className="wr-loading"></div>
                )}
              </div>
              <div className="wr-desc2">
                {tkTime.isValid() ? (
                  <>
                    <FormattedMessage {...messages.waitingRoomDesc2} />
                    <br />
                    <small className="">
                      <FormattedMessage
                        {...messages.waitingRoomLastUpdate}
                        values={{
                          date: tkTime.format("HH:mm:ss"),
                        }}
                      />
                    </small>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  org: makeSelectCurOrg(),
  visitor: makeSelectWaitingRoomVisitor(),
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      fetchWaitingRoomVisitor,
    },
    dispatch
  ),
});

const enhance = flowRight(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
);

export default enhance(WaitingRoom);
